import React from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { clearStorage } from '../../slices/configSlice'
import { clearSiteMap } from '../../slices/siteMapSlice'
import Button from '../library/Button'

export const ResetButton = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const reset = async () => {
    // need to await to be entirely sure localForage is cleared
    await dispatch(clearStorage())
    await dispatch(clearSiteMap())
    navigate('/')
  }

  return <Button onClick={reset}>r</Button>
}

export default ResetButton
